// extracted by mini-css-extract-plugin
export default {"scan_wrap":"style_scan_wrap__300wU","scan_messageBody":"style_scan_messageBody__bkr49"};